import { Button } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

const FilterButton = (props) => (
  <Button color="secondary" startIcon={<FilterListIcon />} {...props} />
);

export default FilterButton;
